module.exports = __webpack_public_path__ + "img/voting-like-dude.53e31ead.svg";